import { DynamicProperty } from "../../components/data-components/DynamicProperty";
import { DynamicPropertyResponse } from "../../api-models/response/DynamicProperty";
import { translationService } from "../translation/TranslationService";
import { IssueResponse } from "../../api-models/response/IssueResponse";
import Language from "../translation/language";
import { formatNumberBasedOnLanguage } from "../../helpers/MathHelpers";
import { format, parseISO } from "date-fns";
import { FieldsFromBM } from "../../api-models/response/BluemetricFields";

export class BaseTechnicalInspection {
  protected dynamicProperties: DynamicProperty[];
  genericIssues: IssueResponse[];

  constructor(
    dynamicPropertiesResponse: DynamicPropertyResponse[],
    genericIssues: IssueResponse[]
  ) {
    this.dynamicProperties = this.mapDynamicPropertiesFromResponse(dynamicPropertiesResponse);
    this.genericIssues = genericIssues;
  }

  mapDynamicPropertiesFromResponse(items: DynamicPropertyResponse[]): DynamicProperty[] {
    const dynamicProperties: DynamicProperty[] = items.map((item) => {
      return new DynamicProperty(item);
    });

    return dynamicProperties;
  }

  getDynamicPropertiesForView() {
    this.dynamicProperties.forEach((item: DynamicProperty) => {
      const value = item.value ? String(item.value).trim() : null;
      if (value && item.isNumericDecimal()) item.value = formatNumberBasedOnLanguage(value);
    });

    return this.dynamicProperties;
  }

  getDynamicPropertiesForEdit() {
    this.dynamicProperties.forEach((item: DynamicProperty) => {
      if (!!item.value && item.isNumericDecimal()) {
        if (translationService.language === Language.german) {
          item.setValue(item.value.replace(".", ","));
        } else {
          item.setValue(item.value.replace(",", "."));
        }
      }
    });

    return this.dynamicProperties;
  }

  getDynamicPropertiesKeyValueForEdit() {
    const extractedFields: FieldsFromBM = {};

    this.dynamicProperties.forEach((item: DynamicProperty) => {
      const id = item.metadata.indicator;
      const value = item.value ? String(item.value).trim() : null;

      extractedFields[id] = value;
      if (value && item.isNumericDecimal())
        extractedFields[id] = formatNumberBasedOnLanguage(value);
    });

    return extractedFields;
  }

  getDynamicPropertyByIndicator(indicator: string) {
    return this.dynamicProperties.find((x) => x.metadata.indicator === indicator);
  }

  getDynamicPropertiesWithDecimalsAndDateFormatted(dynamicPropertiesKeyValue: FieldsFromBM) {
    this.dynamicProperties.forEach((item: DynamicProperty) => {
      const id = item.metadata.indicator;
      const value = dynamicPropertiesKeyValue[id];
      if (value && item.isNumericDecimal() && translationService.language === Language.german) {
        dynamicPropertiesKeyValue[id] = value.replace(",", ".");
      }
      if (value && item.isOfTypeDate()) {
        dynamicPropertiesKeyValue[id] = format(
          parseISO(new Date(value).toISOString()),
          item.metadata.formatString
        );
      }
    });
    return dynamicPropertiesKeyValue;
  }
}
